
import { OktaAuth } from '@okta/okta-auth-js';

const oktaConfig = {
    issuer: 'https://onewp.okta.com/oauth2/default',
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    clientSecret: process.env.REACT_APP_OKTA_SECRET,
    redirectUri: window.location.origin + '/callback',
    scopes: ['openid', 'profile', 'email'],
    hasResponseType: ['code'],
    pkce: false,
  };

const oktaAuth = new OktaAuth(oktaConfig);

export default oktaAuth;